var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMenuUnibet(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M 20.777715,0 H 12 v 19.526539 c 0,6.665822 5.404048,12.069964 12.069868,12.069964 6.665822,0 12.069964,-5.404142 12.069964,-12.069964 V 0 H 27.36131 v 19.526539 c 0,1.818015 -1.473663,3.291678 -3.291442,3.291678 -1.818254,0 -3.292153,-1.473663 -3.292153,-3.291678 z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m 24.070152,48 c 3.555469,0 6.437917,-2.882448 6.437917,-6.438392 0,-3.555707 -2.882448,-6.438153 -6.437917,-6.438153 -3.556182,0 -6.43839,2.882446 -6.43839,6.438153 0,3.555944 2.882208,6.438392 6.43839,6.438392 z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuUnibet);
export default __webpack_public_path__ + "static/media/menu_unibet.43968e2492b87ff04528230ab882434f.svg";
export { ForwardRef as ReactComponent };